import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { BlogAuthorsBlock } from '../../_blocks/BlogAuthors';
import { DefaultContextWidget } from '../_utils/asDefaultWidget/DefaultContextWidget';

export type BlogAuthorsWidget = ContextWidget<BlogAuthorsBlock, WidgetType.blogauthors>;

export function BlogAuthorsWidget(props: BlogAuthorsWidget) {
  const { t } = useTranslation('Blogs');
  return <DefaultContextWidget icon={Icons.BLOG_AUTHORS} title={t('authors.widgetTitle')} {...props} />;
}
